import { TrafficInfoResponse } from '../traffic-info-types';
import styles from './traffic-info-body.module.scss';
import { cleanupHtmlBody } from '../traffic-info-utils';

export interface TrafficInfoBodyProps {
  info: TrafficInfoResponse['infos'][number];
}

export const TrafficInfoBody = ({ info }: TrafficInfoBodyProps): JSX.Element => {
  const body = cleanupHtmlBody(info.descriptionHtml);
  const content = [<div key="html" dangerouslySetInnerHTML={{ __html: body }} />];
  const imageAttachments = info.attachments.filter((attachment) => attachment.fileType.startsWith('image/'));

  for (const attachment of imageAttachments) {
    content.push(<img key={attachment.id} src={attachment.filePath} alt="" />);
  }

  return <div className={styles.TrafficInfoBody}>{content}</div>;
};
